export default "__VITE_ASSET__DVgoTqFn__"